import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import Home from "@/pages/Home";
import DemoPage from "@/pages/DemoPage";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/demos/:slug" element={<DemoPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </LangProvider>
    </div>
  );
}

export default App;
